import React from "react";
import {ProcessType} from "@process/types/process.types";
import {Maybe} from "@src/types/global.types";
import {useSelector} from "react-redux";
import {processState} from "@process/store/processSlice";
import {Col, Row} from "react-bootstrap";
import {ShipmentMethodKeyEnum} from "@shipment/types/shipmentMethod.types";
import {Address} from "@src/components";

interface ProcessShipmentProps{
}

const ProcessShipmentComponent: React.FC<ProcessShipmentProps> = () => {
    const process: Maybe<ProcessType> = useSelector(processState);

    return (
        <Row>
            <Col>
                <div className="p-2 bg-lime-lt">
                    <h3 className="text-body p-0 m-0 text-center fw-normal">Odbiór od klienta</h3>
                </div>

                <dl className="dl-horizontal">
                    <dt>Metoda odbioru:</dt>
                    <dd>{process.incomeShipment.shipmentMethod.name}</dd>
                </dl>

                { process.incomeShipment.department && process.incomeShipment.shipmentMethod.key === ShipmentMethodKeyEnum.personal && (
                    <dl className="dl-horizontal">
                        <dt>Oddział przyjęcia:</dt>
                        <dd>
                            <div>{`${process.incomeShipment.department.code} - ${process.incomeShipment.department.name}`}</div>
                            {process.hasDifferentIncomeShipmentDepartment
                                && process.department.id !== process.incomeShipment.department.id
                                && (
                                <small className="text-red">
                                    Oddział przyjęcia jest inny niż oddział, który obsługuje serwis.
                                </small>
                            )}
                        </dd>
                    </dl>
                )}

                {(process.incomeShipment.shipmentMethod.key === ShipmentMethodKeyEnum.courier
                    || process.incomeShipment.shipmentMethod.key === ShipmentMethodKeyEnum.mobile
                ) && (
                    <dl className="dl-horizontal">
                        <dt>Adres odbioru:</dt>
                        <dd>
                            <Address address={process.incomeShipment.address} />
                            {process.hasDifferentIncomeShipmentAddress && (
                                <small className="text-red">
                                    Adres odbioru jest inny niż adres klienta.
                                </small>
                            )}
                        </dd>
                    </dl>
                )}
            </Col>
            <Col>
                <div className="p-2 bg-cyan-lt">
                    <h3 className="text-body p-0 m-0 text-center fw-normal">Zwrot do klienta</h3>
                </div>
                <dl className="dl-horizontal">
                    <dt>Metoda zwrotu:</dt>
                    <dd>{process.shipment.shipmentMethod.name}</dd>
                </dl>


                { process.shipment.department && process.shipment.shipmentMethod.key === ShipmentMethodKeyEnum.personal && (
                    <dl className="dl-horizontal">
                        <dt>Oddział wydania:</dt>
                        <dd>
                            <div>{`${process.shipment.department.code} - ${process.shipment.department.name}`}</div>
                            {process.hasDifferentShipmentDepartment
                                && process.department.id !== process.shipment.department.id
                                && (
                                <small className="text-red">
                                    Oddział wydania jest inny niż oddział, który obsługuje serwis.
                                </small>
                            )}
                        </dd>
                    </dl>
                )}

                {(process.shipment.shipmentMethod.key === ShipmentMethodKeyEnum.courier
                    || process.shipment.shipmentMethod.key === ShipmentMethodKeyEnum.mobile
                ) && (
                    <dl className="dl-horizontal">
                        <dt>Adres odbioru:</dt>
                        <dd>
                            <Address address={process.shipment.address} />
                            {process.hasDifferentShipmentAddress && (
                                <small className="text-red">
                                    Adres dostawy jest inny niż adres klienta..
                                </small>
                            )}
                        </dd>
                    </dl>
                )}

            </Col>
        </Row>
    );
};

export default ProcessShipmentComponent;